"use client";

import styles from "./BlogList.module.scss";
import BlogCard from "@molecules/BlogCard";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";

export default function BlogList({ data, title }:{ data: any, title: string }) {
  return (
    <div className={`px-3 ${styles.root}`}>
      <Carousel
        children={data?.map((d, index) => (
          <BlogCard 
            key={index} 
            id={index} 
            {...d} 
            title={title}
          />
        ))}
        config={{
          freeMode: true,
          pagination:{
            status: false
          },
          autoplay: {
            status: false
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            481: {
              slidesPerView: 1.2,
              spaceBetween: 16
            },
            650: {
              slidesPerView: 1.5,
              spaceBetween: 16
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 16
            },
            1024: {
              slidesPerView: 2.5,
              spaceBetween: 20
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            1920: {
              slidesPerView: 4,
              spaceBetween: 50
            }
          }
        }}
      />
    </div>
  )
}
